import React, {type FC} from 'react'
import {useGetAdaptiveStyle} from '../hooks/useGetAdaptiveStyle'
import {LetterButton} from '../LetterButton/LetterButton'
import type {KeyboardViewType, Letters} from './types'
import styles from './LettersBox.scss'

type Props = {
  prefix: string
  view: KeyboardViewType
  letters: Letters
  onLetterClick: (letter: string) => void
}

export const LettersBox: FC<Props> = (props) => {
  const {letters, view, prefix, onLetterClick} = props
  const {heightSize, widthSize, isTooSmallScreen, style} = useGetAdaptiveStyle([
    {
      cssKey: 'rowGap',
      axis: 'height',
      params: [30, 10, 3, 1, 1, 1, 1]
    }
  ])
  if (heightSize === 'xs' && widthSize === 'xs' || isTooSmallScreen) {
    style.minHeight = 120
  }
  
  return (
    <div className={styles.letters} style={style}>
      {view.map((item, key) => (
        <div className={styles.column} key={key}>
          {item.map((letter) => (
            <LetterButton
              key={`${prefix}${letter}`}
              isActive={letters[letter]}
              symbol={letter}
              onClick={onLetterClick}
            />
          ))}
        </div>
      ))}        
    </div>
  )
}
